import Head from 'next/head';
import { useRouter } from 'next/router';

import { FilterableField } from 'hooks/useGlobalSearch/useGlobalSearchInternal';
import { useGlobalSearch } from 'lib/providers/GlobalSearchProvider';
import { SearchPageType } from 'lib/utils/global.search';

export const PageHeadMeta = ({ initialPageHead }: { initialPageHead?: JSX.Element }) => {
  const { query } = useRouter();
  const { requestedPageType, originalType, currentFilters, hasRequestedPageTypeChanged } = useGlobalSearch();

  if (!hasRequestedPageTypeChanged && initialPageHead) {
    return initialPageHead;
  }

  let title, description;
  const year = new Date().getFullYear();

  const type = originalType || requestedPageType;

  switch (type) {
    case SearchPageType.JOBS:
      title = `Jobs | ${year}`;
      description = 'Apply to jobs on Huzzle, the top careers network for students.';
      break;
    case SearchPageType.INTERNSHIPS:
      title = `Internships | ${year}`;
      description = 'Apply to internships on Huzzle, the top careers network for students.';
      break;
    case SearchPageType.EVENTS:
      title = `Events | ${year}`;
      description = 'Find the top events on Huzzle, register in minutes.';
      break;
    case SearchPageType.COMPANIES:
      title = `Companies | Huzzle`;
      description =
        'View thousands of Companies and filter them by Industry and Company Size! Click on their profiles to find all their jobs, internships & events.';
      break;
    case SearchPageType.COMMUNITIES: {
      const field = currentFilters.find((filter) => filter.id === FilterableField.VERIFIED);
      const verified = field ? query[field.param] === 'true' : false;
      title = `Student Clubs & Societies | Huzzle`;
      description = verified
        ? 'View all the Verified Clubs & Societies and filter them by university and topics of focus to find your favourites! Click on their profiles to discover more.'
        : 'View all the Clubs & Societies and filter them by university and topics of focus to find your favourites! Click on their profiles to discover more.';
      break;
    }
    default:
      title = `Explore | Huzzle`;
      description =
        'Explore 120,000+ Jobs, Internships & Events on Huzzle. Utilise powerful tools for job search, create CV with AI & apply to millions of jobs with 1 click with our extension.';
  }

  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={description} />
    </Head>
  );
};

export default PageHeadMeta;

PageHeadMeta.displayName = 'PageHeadMeta';
